import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { AlertTriangle, ExternalLink } from 'lucide-react';

const fmtDatum = (s: any) => {
  if (!s) return '';
  const m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : String(s);
};

const ajpesUrl = (p: any) => {
  const base = 'https://www.ajpes.si/eObjave/rezultati.asp?Sodisce=-1&MAXREC=50&id_skupina=51&podrobno=0';
  if (p?.davcna) return base + '&DS=' + encodeURIComponent(p.davcna);
  if (p?.maticna) return base + '&MS=' + encodeURIComponent(p.maticna);
  return 'https://www.ajpes.si/eObjave/';
};

export function InsolventnostOpozorilo({ partnerId, davcna, maticna, compact }: {
  partnerId?: string | null;
  davcna?: string | null;
  maticna?: string | null;
  compact?: boolean;
}) {
  const [postopek, setPostopek] = useState<any>(null);

  useEffect(() => {
    setPostopek(null);
    if (!partnerId && !davcna && !maticna) return;
    const params: any = {};
    if (partnerId) params.partner_id = partnerId;
    if (davcna) params.davcna = davcna;
    if (maticna) params.maticna = maticna;
    let zivo = true;
    api.get('/insolventnost/preveri', { params })
      .then((r: any) => { if (zivo && r.data?.insolventen) setPostopek(r.data.postopek); })
      .catch(() => {});
    return () => { zivo = false; };
  }, [partnerId, davcna, maticna]);

  if (!postopek) return null;

  const status = postopek.status || 'aktiven';
  const odKdaj = postopek.od_kdaj || postopek.datum_zacetka || postopek.datum_objave;
  const pravi = !!postopek.datum_zacetka;
  const jeAmber = status === 'potrjena_pp';

  const wrap = compact ? 'px-3 py-2 text-xs' : 'px-4 py-3 text-sm';
  const ikona = compact ? 'w-4 h-4 mt-0.5 flex-shrink-0' : 'w-5 h-5 mt-0.5 flex-shrink-0';
  const barva = jeAmber
    ? 'border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/30 text-amber-800 dark:text-amber-200'
    : 'border-red-300 dark:border-red-700 bg-red-50 dark:bg-red-900/30 text-red-800 dark:text-red-200';

  return (
    <div className={'flex items-start gap-2 rounded-lg border ' + barva + ' ' + wrap}>
      <AlertTriangle className={ikona} />
      <div className="flex-1">
        {jeAmber ? (
          <>
            <span className="font-semibold">Opomba &ndash; prisilna poravnava.</span>{' '}
            <span className="font-medium">{postopek.naziv || 'Dobavitelj'}</span> je bil v postopku prisilne poravnave
            {odKdaj ? ` od ${fmtDatum(odKdaj)}` : ''}
            {postopek.datum_konca ? `, potrjena ${fmtDatum(postopek.datum_konca)}` : ''}.{' '}
            Postopek je zaključen; podjetje praviloma posluje normalno.{' '}
            <a href={ajpesUrl(postopek)} target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-0.5 underline hover:no-underline whitespace-nowrap">
              AJPES <ExternalLink className="w-3 h-3" />
            </a>
          </>
        ) : (
          <>
            <span className="font-semibold">Pozor &ndash; insolventnost dobavitelja.</span>{' '}
            <span className="font-medium">{postopek.naziv || 'Dobavitelj'}</span> je
            {odKdaj ? ` od ${fmtDatum(odKdaj)}` : ''} v postopku:{' '}
            <span className="font-medium">{postopek.vrsta_postopka || 'insolvenčni postopek'}</span>
            {postopek.opravilna_st ? ` (opr. št. ${postopek.opravilna_st})` : ''}.
            {status === 'zakljucen' && postopek.datum_konca ? ` Postopek zaključen ${fmtDatum(postopek.datum_konca)}.` : ''}{' '}
            <a href={ajpesUrl(postopek)} target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-0.5 underline hover:no-underline whitespace-nowrap">
              AJPES <ExternalLink className="w-3 h-3" />
            </a>
            {!pravi && odKdaj ? (
              <span className="block opacity-70 mt-0.5">
                Datum je najzgodnejša zaznana objava (približek začetka postopka).
              </span>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}
